import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const getToken = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// ============================================
// MÉTRICAS DE ATENDIMENTO
// ============================================
export const getMyAttendanceMetrics = (startDate, endDate) =>
  axios.get(`${API}/api/attendance/my-metrics`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getTenantAttendanceMetrics = (startDate, endDate) =>
  axios.get(`${API}/api/attendance/tenant-metrics`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getConversationMetrics = (conversationId) =>
  axios.get(`${API}/api/attendance/conversation/${conversationId}`, getToken());

export const updateSatisfaction = (conversationId, rating) =>
  axios.put(`${API}/api/attendance/conversation/${conversationId}/satisfaction`, 
    { rating }, getToken());

export const getHeatmapData = (userId) =>
  axios.get(`${API}/api/attendance/heatmap/${userId || ''}`, getToken());

// ============================================
// RELATÓRIOS
// ============================================
export const getMyDailyReport = (date) =>
  axios.get(`${API}/api/reports/my-daily`, {
    ...getToken(),
    params: { date }
  });

export const getMyPeriodReport = (startDate, endDate) =>
  axios.get(`${API}/api/reports/my-period`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getTenantDailyReport = (date) =>
  axios.get(`${API}/api/reports/tenant-daily`, {
    ...getToken(),
    params: { date }
  });

export const getTenantPeriodReport = (startDate, endDate) =>
  axios.get(`${API}/api/reports/tenant-period`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getAttendantRanking = (startDate, endDate) =>
  axios.get(`${API}/api/reports/attendant-ranking`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getConversionByType = (startDate, endDate) =>
  axios.get(`${API}/api/reports/conversion-by-type`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getPeriodComparison = (params) =>
  axios.get(`${API}/api/reports/period-comparison`, {
    ...getToken(),
    params
  });

// ============================================
// METAS
// ============================================
export const getMyGoals = () =>
  axios.get(`${API}/api/performance/goals`, getToken());

export const createGoal = (data) =>
  axios.post(`${API}/api/performance/goals`, data, getToken());

export const updateGoal = (id, data) =>
  axios.put(`${API}/api/performance/goals/${id}`, data, getToken());

export const deleteGoal = (id) =>
  axios.delete(`${API}/api/performance/goals/${id}`, getToken());

// ============================================
// CONQUISTAS
// ============================================
export const getAllAchievements = () =>
  axios.get(`${API}/api/achievements`, getToken());

export const getMyAchievements = () =>
  axios.get(`${API}/api/achievements/my`, getToken());

export const getTenantRanking = (limit = 10) =>
  axios.get(`${API}/api/achievements/ranking`, {
    ...getToken(),
    params: { limit }
  });

// ============================================
// AGENDAMENTOS
// ============================================
// ============================================
// AGENDAMENTOS
// ============================================
export const createAppointment = (data) =>
  axios.post(`${API}/api/appointments`, data, getToken());

export const getMyAppointments = (startDate, endDate) =>
  axios.get(`${API}/api/appointments/my`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const getTenantAppointments = (startDate, endDate) =>
  axios.get(`${API}/api/appointments/tenant`, {
    ...getToken(),
    params: { startDate, endDate }
  });

export const updateAppointmentStatus = (id, status) =>
  axios.put(`${API}/api/appointments/${id}/status`, { status }, getToken());

// ⭐ NOVAS FUNÇÕES - Adicione estas 3:
export const updateAppointment = (id, data) =>
  axios.put(`${API}/api/appointments/${id}`, data, getToken());

export const deleteAppointment = (id) =>
  axios.delete(`${API}/api/appointments/${id}`, getToken());

export const sendAppointmentReminder = (id, channel) =>
  axios.post(`${API}/api/appointments/${id}/send-reminder`, { channel }, getToken());
// ============================================
// ALERTAS
// ============================================
export const getMyAlerts = (limit = 50) =>
  axios.get(`${API}/api/alerts/my`, {
    ...getToken(),
    params: { limit }
  });

export const getUnreadAlerts = () =>
  axios.get(`${API}/api/alerts/unread`, getToken());

export const markAlertAsRead = (id) =>
  axios.put(`${API}/api/alerts/${id}/read`, {}, getToken());

export const markAllAlertsAsRead = () =>
  axios.put(`${API}/api/alerts/read-all`, {}, getToken());

// ============================================
// BI
// ============================================
export const getBIConfigurations = () =>
  axios.get(`${API}/api/bi/configurations`, getToken());

export const createBIConfiguration = (data) =>
  axios.post(`${API}/api/bi/configurations`, data, getToken());

export const getMyDirectMetrics = () =>
  axios.get(`${API}/api/attendance/my-direct-metrics`, getToken());

export const exportToBI = (biTool) =>
  axios.post(`${API}/api/bi/export`, {}, {
    ...getToken(),
    params: { bi_tool: biTool }
  });


